import { regions } from "./locales";

export function getCityStateBySlug(
  slug: string
): { city: string; state: string; codeState: string } | null {
  const lowerSlug = slug.toLowerCase();

  for (const region of regions) {
    for (const city of region.cities) {
      if (city.slug === lowerSlug || city.stateSlug === lowerSlug) {
        return {
          city: city.name,
          state: city.state,
          codeState: city.stateCode,
        };
      }
    }
  }

  return null;
}
